module.exports = __webpack_public_path__ + "img/base-whiteman.fb497e23.svg";